<template>
  <resource-loader :task="task">
    Authentication failed.
  </resource-loader>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import ResourceLoader from '@/components/loading/ResourceLoader.vue';
import { callback } from './index';

interface Data {
  task: Promise<void>|null,
}

export default defineComponent({
  components: {
    ResourceLoader,
  },
  props: {
    platform: {
      type: String,
      required: true,
    },
  },
  data(): Data {
    return {
      task: null,
    };
  },
  watch: {
    platform: {
      handler() {
        this.callback();
      },
      immediate: true,
    },
  },
  methods: {
    callback() {
      this.task = callback(this.platform, this.$route.query);
    },
  },
});
</script>
